module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 195);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Spacing;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var spacingTypes = ['margin', 'padding'];
var spacingSizes = ['0', 'xxs', 'xs', 's', 'm', 'l', 'xl'];
var spacingPositions = {
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  topBottom: 'TopBottom',
  leftRight: 'LeftRight',
  none: ''
};

function Spacing(_ref) {
  var _cx;

  var children = _ref.children,
      type = _ref.type,
      position = _ref.position,
      size = _ref.size,
      sizeS = _ref.sizeS,
      sizeM = _ref.sizeM,
      sizeL = _ref.sizeL;

  var spacingPosition = position ? spacingPositions[position] : '';
  var spacingClass = (0, _classnames2.default)('' + type + spacingPosition + '-' + size, (_cx = {}, _defineProperty(_cx, 'breakPointS-' + type + spacingPosition + '-' + sizeS, sizeS), _defineProperty(_cx, 'breakPointM-' + type + spacingPosition + '-' + sizeM, sizeM), _defineProperty(_cx, 'breakPointL-' + type + spacingPosition + '-' + sizeL, sizeL), _cx));

  return _react2.default.createElement(
    'div',
    { className: spacingClass },
    children
  );
}

Spacing.propTypes = {
  children: _propTypes2.default.node.isRequired,
  position: _propTypes2.default.oneOf(Object.keys(spacingPositions)),
  size: _propTypes2.default.oneOf(spacingSizes),
  sizeL: _propTypes2.default.oneOf(spacingSizes),
  sizeM: _propTypes2.default.oneOf(spacingSizes),
  sizeS: _propTypes2.default.oneOf(spacingSizes),
  type: _propTypes2.default.oneOf(spacingTypes)
};

Spacing.defaultProps = {
  position: 'none',
  type: 'margin'
};

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logos = undefined;

var _Logos = __webpack_require__(196);

Object.defineProperty(exports, 'logos', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Logos).default;
  }
});

var _LogoRow = __webpack_require__(205);

var _LogoRow2 = _interopRequireDefault(_LogoRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LogoRow2.default;

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BlaBlaCar = __webpack_require__(197);

var _BlaBlaCar2 = _interopRequireDefault(_BlaBlaCar);

var _Buzzfeed = __webpack_require__(198);

var _Buzzfeed2 = _interopRequireDefault(_Buzzfeed);

var _Cabify = __webpack_require__(199);

var _Cabify2 = _interopRequireDefault(_Cabify);

var _Deliveroo = __webpack_require__(200);

var _Deliveroo2 = _interopRequireDefault(_Deliveroo);

var _Ibm = __webpack_require__(201);

var _Ibm2 = _interopRequireDefault(_Ibm);

var _Monzo = __webpack_require__(202);

var _Monzo2 = _interopRequireDefault(_Monzo);

var _Stripe = __webpack_require__(203);

var _Stripe2 = _interopRequireDefault(_Stripe);

var _Trainline = __webpack_require__(204);

var _Trainline2 = _interopRequireDefault(_Trainline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logos = [{
  id: 0,
  logo: _Buzzfeed2.default
}, {
  id: 1,
  logo: _Monzo2.default
}, {
  id: 2,
  logo: _Cabify2.default
}, {
  id: 3,
  logo: _Ibm2.default
}, {
  id: 4,
  logo: _Stripe2.default
}, {
  id: 5,
  logo: _Trainline2.default
}, {
  id: 6,
  logo: _Deliveroo2.default
}, {
  id: 7,
  logo: _BlaBlaCar2.default
}];

exports.default = logos;

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BlaBlaCar;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BlaBlaCar() {
  return _react2.default.createElement(
    "svg",
    { width: "110", height: "40", viewBox: "0 0 110 40" },
    _react2.default.createElement("path", { d: "M21.2,17.22a6,6,0,0,0-6.89-5l.95-5.59L11.76,6a35.32,35.32,0,0,0-2.25,7.17,6.1,6.1,0,0,1,2.54,4,6.18,6.18,0,0,1-1.29,4.9,5.47,5.47,0,0,0,.9.9,5.79,5.79,0,0,0,4.62,1.24,6.06,6.06,0,0,0,4.91-7Z" }),
    _react2.default.createElement("path", { d: "M9.45,13.56l.07-.38a5.88,5.88,0,0,0-4.38-1l1-5.57L2.6,6A33.59,33.59,0,0,0,.28,13.54c-.48,2.9-.46,6,1,8.19A5.88,5.88,0,0,0,2.5,23a5.78,5.78,0,0,0,4.63,1.24,6,6,0,0,0,3.63-2.12l-.28-.38C9,19.56,9,16.45,9.45,13.56Z" }),
    _react2.default.createElement("path", { d: "M91.62,23H89.54a.14.14,0,0,0-.15.09A4.17,4.17,0,0,1,88.1,25a4,4,0,0,1-5.48-.89,6.76,6.76,0,0,1-1.14-4,6.63,6.63,0,0,1,1.14-4,3.81,3.81,0,0,1,3.15-1.59,3.68,3.68,0,0,1,2.31.71,4.5,4.5,0,0,1,1.3,1.89.15.15,0,0,0,.14.11h2.19a.17.17,0,0,0,0-.1,6.06,6.06,0,0,0-2-3.43,6.16,6.16,0,0,0-4-1.3A6.32,6.32,0,0,0,81,14.51a8.43,8.43,0,0,0-2,5.66,8.43,8.43,0,0,0,2,5.66,6.53,6.53,0,0,0,8.76.88,6,6,0,0,0,2-3.47.11.11,0,0,0,0-.11h-.1Zm18.29-6.29a3.47,3.47,0,0,0-.64-.06,4.6,4.6,0,0,0-.91.09,3.27,3.27,0,0,0-.9.34,3.88,3.88,0,0,0-.85.66,3.19,3.19,0,0,0-.43.54l-.09.15V17a.17.17,0,0,0-.15-.16h-2a.16.16,0,0,0-.14.16V27.62a.15.15,0,0,0,.14.15h2a.17.17,0,0,0,.16-.15V22.47a5.64,5.64,0,0,1,.2-1.53,2.32,2.32,0,0,1,.59-1,2.59,2.59,0,0,1,.92-.57,3.52,3.52,0,0,1,1.25-.2,4.87,4.87,0,0,1,.76.06.15.15,0,0,0,.11,0,.14.14,0,0,0,0-.11V16.9a.11.11,0,0,0-.11-.16ZM66.68,12.33l-2,.36a.16.16,0,0,0-.15.15V27.61a.17.17,0,0,0,.17.17h2a.16.16,0,0,0,.15-.17V12.5A.18.18,0,0,0,66.68,12.33ZM62.52,21.1a4.76,4.76,0,0,0-1.21-1.57l-.15-.11a4.05,4.05,0,0,0-.71-.45h0a3.86,3.86,0,0,0,.92-2.49A4.32,4.32,0,0,0,61,14.74a3.82,3.82,0,0,0-.93-1.32,4,4,0,0,0-1.3-.81,4.94,4.94,0,0,0-1.86-.3H52.46a.17.17,0,0,0-.16.17V27.6a.17.17,0,0,0,.16.17H58a6.16,6.16,0,0,0,2-.27,4.53,4.53,0,0,0,1.39-.78,4.87,4.87,0,0,0,1.21-1.57c.07-.15.13-.28.18-.41v-.17A5.1,5.1,0,0,0,63,23.12a4.64,4.64,0,0,0-.48-2Zm-7.85-6.5h1.87a4.91,4.91,0,0,1,1.32.15,1.77,1.77,0,0,1,.66.45A1.91,1.91,0,0,1,59,16.47a1.72,1.72,0,0,1-.47,1.25,1.66,1.66,0,0,1-.66.45,3.31,3.31,0,0,1-.88.15H54.65V14.6ZM60.39,24a2.42,2.42,0,0,1-.48.78,2.53,2.53,0,0,1-.86.55,4.61,4.61,0,0,1-1.52.2H54.66v-4.9h2.87a4.55,4.55,0,0,1,1.51.2,2.4,2.4,0,0,1,.85.55,3.19,3.19,0,0,1,.49.76,2.39,2.39,0,0,1,.18.92,2.53,2.53,0,0,1-.18.94Zm16-6.24a4.46,4.46,0,0,0-3.18-1.08,4.6,4.6,0,0,0-2.93.89,4,4,0,0,0-1.4,1.91.14.14,0,0,0,0,.11.17.17,0,0,0,.1.07l1.9.34a.12.12,0,0,0,.11-.1,2.17,2.17,0,0,1,2.19-1.29,2.07,2.07,0,0,1,1.67.59,2,2,0,0,1,.6,1.66v.39a9.6,9.6,0,0,0-2.81-.45,4.93,4.93,0,0,0-3.12,1,3.22,3.22,0,0,0-1.25,2.7,3.18,3.18,0,0,0,1.15,2.6,4.12,4.12,0,0,0,2.73.94,4.45,4.45,0,0,0,3.32-1.24v.84a.19.19,0,0,0,.18.18h1.75a.17.17,0,0,0,.17-.18V20.71a3.9,3.9,0,0,0-1.21-3Zm-1.77,7.47a3.18,3.18,0,0,1-2.15.74A2.22,2.22,0,0,1,71,25.52a1.46,1.46,0,0,1-.49-1.16,1.36,1.36,0,0,1,.63-1.21,3,3,0,0,1,1.62-.41,9.26,9.26,0,0,1,2.71.44,2.44,2.44,0,0,1-.88,2ZM39.47,12.33l-2,.36a.19.19,0,0,0-.14.15V27.61a.17.17,0,0,0,.16.17h2a.17.17,0,0,0,.14-.17V12.5A.17.17,0,0,0,39.47,12.33ZM35.29,21.1a4.73,4.73,0,0,0-1.2-1.57l-.15-.11a3.35,3.35,0,0,0-.72-.45h0a3.86,3.86,0,0,0,.92-2.49,4.23,4.23,0,0,0-.33-1.65,3.82,3.82,0,0,0-.93-1.32,3.86,3.86,0,0,0-1.29-.81,4.94,4.94,0,0,0-1.86-.3H25.27a.18.18,0,0,0-.12,0,.17.17,0,0,0,0,.12v15a.17.17,0,0,0,.16.17h5.47a6.16,6.16,0,0,0,2-.27,4.7,4.7,0,0,0,1.4-.78,4.87,4.87,0,0,0,1.21-1.57c.07-.15.12-.28.17-.41v-.17a4.5,4.5,0,0,0,.24-1.45,4.78,4.78,0,0,0-.48-2Zm-7.85-6.5h1.87a4.91,4.91,0,0,1,1.32.15,1.66,1.66,0,0,1,.66.45,1.82,1.82,0,0,1,.48,1.27,1.77,1.77,0,0,1-.48,1.25,1.45,1.45,0,0,1-.66.45,3.31,3.31,0,0,1-.88.15H27.44ZM33.18,24a2.64,2.64,0,0,1-.49.78,2.53,2.53,0,0,1-.86.55,4.63,4.63,0,0,1-1.53.2H27.44v-4.9H30.3a4.63,4.63,0,0,1,1.53.2,2.44,2.44,0,0,1,.86.55,2.91,2.91,0,0,1,.49.76,2.39,2.39,0,0,1,.18.92,2.36,2.36,0,0,1-.19.94Zm16-6.24A4.47,4.47,0,0,0,46,16.66a4.6,4.6,0,0,0-2.93.89,4,4,0,0,0-1.4,1.91.17.17,0,0,0,0,.12.17.17,0,0,0,.1.06l1.88.34a.15.15,0,0,0,.17-.08A2.15,2.15,0,0,1,46,18.61a2.11,2.11,0,0,1,2.28,2.25v.39a9.8,9.8,0,0,0-2.84-.45,4.91,4.91,0,0,0-3.11,1,3.17,3.17,0,0,0-1.25,2.7,3.21,3.21,0,0,0,1.12,2.6,4.13,4.13,0,0,0,2.74.94,4.49,4.49,0,0,0,3.32-1.24v.84a.17.17,0,0,0,.17.18h1.75a.17.17,0,0,0,.18-.18V20.71a3.85,3.85,0,0,0-1.2-3Zm-1.79,7.47a3.26,3.26,0,0,1-2.16.74,2.17,2.17,0,0,1-1.44-.43,1.45,1.45,0,0,1-.51-1.16,1.36,1.36,0,0,1,.63-1.21,3,3,0,0,1,1.62-.41,9.26,9.26,0,0,1,2.71.44,2.39,2.39,0,0,1-.86,2ZM101,17.74a4.48,4.48,0,0,0-3.19-1.08,4.66,4.66,0,0,0-2.93.89,4.17,4.17,0,0,0-1.4,1.91.17.17,0,0,0,.13.18L95.5,20a.13.13,0,0,0,.15-.08,2.15,2.15,0,0,1,2.18-1.29,2.08,2.08,0,0,1,2.28,2.25v.39a9.73,9.73,0,0,0-2.83-.45,4.91,4.91,0,0,0-3.11,1,3.22,3.22,0,0,0-1.25,2.7A3.2,3.2,0,0,0,94,27.06a4.12,4.12,0,0,0,2.73.94,4.48,4.48,0,0,0,3.33-1.24v.84a.18.18,0,0,0,.18.18H102a.17.17,0,0,0,.18-.18V20.71a4,4,0,0,0-1.21-3Zm-1.79,7.47A3.2,3.2,0,0,1,97,26a2.16,2.16,0,0,1-1.43-.43,1.44,1.44,0,0,1-.5-1.16,1.35,1.35,0,0,1,.64-1.21,2.91,2.91,0,0,1,1.61-.41,9.26,9.26,0,0,1,2.71.44,2.44,2.44,0,0,1-.88,2Z" })
  );
}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Buzzfeed;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Buzzfeed() {
  return _react2.default.createElement(
    "svg",
    { width: "86", height: "40", viewBox: "0 0 86 40" },
    _react2.default.createElement("path", { d: "M0,25.78V11H6.62c2.87,0,4.27,1.8,4.27,3.76a3.29,3.29,0,0,1-2.56,3.39,3.59,3.59,0,0,1,2.87,3.62c0,2.23-1.47,4-4.32,4ZM7.64,15.32a1.49,1.49,0,0,0-.5-1.15,1.57,1.57,0,0,0-1.21-.4H3.16v3.1H5.93a1.55,1.55,0,0,0,1.22-.39A1.51,1.51,0,0,0,7.64,15.32Zm.32,6a1.66,1.66,0,0,0-.57-1.27,1.71,1.71,0,0,0-1.34-.41H3.18V23h2.9A1.65,1.65,0,0,0,8,21.35Z" }),
    _react2.default.createElement("path", { d: "M12.05,21.49V15.08h2.87V21.4A2,2,0,0,0,15.54,23a2.11,2.11,0,0,0,1.66.57A2.08,2.08,0,0,0,18.86,23a2,2,0,0,0,.62-1.62V15.08h2.87v6.4c-.06,2.7-1.68,4.58-5.15,4.58S12.05,24.18,12.05,21.49Z" }),
    _react2.default.createElement("path", { d: "M23.23,25.78V23.67l4.85-6.14H23.23V15.08h8.7v2L27,23.32h5v2.46Z" }),
    _react2.default.createElement("path", { d: "M33,25.78V23.67l4.84-6.14H33V15.08h8.69v2L36.7,23.32h5v2.46Z" }),
    _react2.default.createElement("path", { d: "M42.79,25.78V11h10.3v2.77H46v3.1h5.37v2.77H46v6.14Z" }),
    _react2.default.createElement("path", { d: "M52.13,20.41a5.37,5.37,0,0,1,1.55-4,5.57,5.57,0,0,1,4-1.66c3.23.05,5.38,2.45,5.38,5.92v.67h-8a2.84,2.84,0,0,0,3.09,2.4,4.48,4.48,0,0,0,2.87-1l1.27,1.88a6.78,6.78,0,0,1-4.44,1.47,5.51,5.51,0,0,1-4.14-1.57A5.32,5.32,0,0,1,52.13,20.41Zm5.56-3.29a2.48,2.48,0,0,0-2.63,2.28h5.3a2.45,2.45,0,0,0-2.67-2.28Z" }),
    _react2.default.createElement("path", { d: "M63.84,20.41a5.34,5.34,0,0,1,1.56-4,5.55,5.55,0,0,1,4-1.66c3.22,0,5.38,2.4,5.38,5.88v.71h-8a2.87,2.87,0,0,0,3.09,2.4,4.61,4.61,0,0,0,2.87-1L74,24.59a6.78,6.78,0,0,1-4.44,1.47,5.54,5.54,0,0,1-4.14-1.57A5.39,5.39,0,0,1,63.84,20.41Zm5.56-3.29a2.48,2.48,0,0,0-2.63,2.28h5.3a2.45,2.45,0,0,0-2.67-2.28Z" }),
    _react2.default.createElement("path", { d: "M75.82,25.8V15.06h4.33c3.4,0,5.85,2,5.85,5.35s-2.44,5.38-5.83,5.38Zm7.43-5.39a2.82,2.82,0,0,0-.8-2.18,2.9,2.9,0,0,0-2.18-.86H78.51v6.11h1.76a3,3,0,0,0,2.16-.9A2.93,2.93,0,0,0,83.25,20.41Z" })
  );
}

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cabify;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Cabify() {
  return _react2.default.createElement(
    "svg",
    { width: "90", height: "40", viewBox: "0 0 90 40" },
    _react2.default.createElement("path", { d: "M12.4,16.26a4.16,4.16,0,0,1,2.92,1.2,4.14,4.14,0,0,0,5.85-5.85A12.41,12.41,0,0,0,3.63,29.17l8.77,8.77,8.77-8.77a4.14,4.14,0,0,0-5.85-5.85L12.4,26.25,9.49,23.32a4.14,4.14,0,0,1,2.91-7.06ZM8,24.8l4.39,4.39,4.4-4.39a2.06,2.06,0,0,1,2.91,2.91L12.42,35,5.09,27.71A10.34,10.34,0,0,1,19.71,13.09,2.06,2.06,0,1,1,16.8,16,6.22,6.22,0,0,0,8,24.8Zm40.9-9.15a5.12,5.12,0,0,0-3.63-1.46,5.91,5.91,0,0,0-5.88,6.21A6,6,0,0,0,41,24.77a5.89,5.89,0,0,0,4.27,1.84,5.12,5.12,0,0,0,3.63-1.46V26.3h2.2V14.51l-2.2.19Zm-3.6,8.87c-2,0-3.62-1.6-3.62-4.14s1.63-4.12,3.62-4.14,3.61,1.61,3.61,4.14S47.26,24.52,45.3,24.52ZM33.55,16.26a3.57,3.57,0,0,1,3.08,1.92L38.54,17a5.69,5.69,0,0,0-5-2.83,5.88,5.88,0,0,0-5.87,6.21,5.88,5.88,0,0,0,5.87,6.21,5.69,5.69,0,0,0,5-2.83L36.63,22.6a3.53,3.53,0,0,1-3.08,1.92c-2,0-3.61-1.6-3.61-4.14S31.58,16.28,33.55,16.26Zm25.69-2.07a5.12,5.12,0,0,0-3.63,1.46V10.07l-2.2.19v16h2.2V25.15a5.12,5.12,0,0,0,3.63,1.46,5.9,5.9,0,0,0,5.87-6.21,5.9,5.9,0,0,0-5.87-6.21Zm0,10.33c-2,0-3.61-1.6-3.61-4.14s1.62-4.12,3.61-4.14,3.61,1.61,3.61,4.14S61.2,24.52,59.24,24.52Zm28.08-10-3.38,7.75-3.62-7.75H75.63v-1c0-1.2.57-1.71,1.74-1.71a5.34,5.34,0,0,1,1.2.17l.53-1.84a7.47,7.47,0,0,0-2.3-.36,3.27,3.27,0,0,0-3.51,3.6v1.18l-2,.17v1.86h2V26.3h2.34V16.54H78.7l4.07,8.36A5.45,5.45,0,0,1,81.36,27a2.41,2.41,0,0,1-2,.36l-.55,1.9A4.33,4.33,0,0,0,82.14,29a5.68,5.68,0,0,0,2.28-2.79l5.39-11.76H87.32ZM68.2,9.73a1.6,1.6,0,1,0,1.6,1.61A1.63,1.63,0,0,0,68.2,9.73ZM67,26.27h2.34V14.51L67,14.72Z" })
  );
}

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Deliveroo;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Deliveroo() {
  return _react2.default.createElement(
    "svg",
    { width: "115", height: "40", viewBox: "0 0 115 40" },
    _react2.default.createElement("path", { d: "M19.51,22.45c-.3.51-1,.59-1.81.21a1.13,1.13,0,0,1-.44-1.27,1,1,0,0,1,.25-.59,1.2,1.2,0,0,1,.82-.54,1.4,1.4,0,0,1,1.32.7A1.46,1.46,0,0,1,19.51,22.45Zm-5.6-.62a1.39,1.39,0,0,1-1.48.15c-.56-.19-.79-.85-.61-1.7.17-.61.89-.71,1.28-.71a.87.87,0,0,1,.42.1c.25.11.7.37.79.75A1.34,1.34,0,0,1,13.91,21.83ZM20,2,18.61,15.66,16.19,4.14,8.57,5.77,11,17.29,0,19.64l2,9.19L21.25,33l4.42-10L27.76,2.82ZM62.74,14a1.59,1.59,0,0,0,1.11-.48,1.55,1.55,0,0,0,.44-1.12,1.55,1.55,0,0,0-1.55-1.6,1.6,1.6,0,0,0,0,3.2Zm-6,11.21h2.48V11H56.77Zm41.3.21a4.81,4.81,0,0,0,4.9-5.13,4.91,4.91,0,1,0-9.8,0,4.83,4.83,0,0,0,4.93,5.12Zm-17.73,0a6.92,6.92,0,0,0,3.88-1.13l-1-2.16a6,6,0,0,1-2.9.75,2.63,2.63,0,0,1-2.63-1.48h7a6.42,6.42,0,0,0,.11-1.16,4.86,4.86,0,1,0-9.71.05,4.81,4.81,0,0,0,5.28,5.12ZM114,20.28a4.91,4.91,0,1,0-9.8,0,4.91,4.91,0,1,0,9.8,0ZM50.66,25.39a7.22,7.22,0,0,0,3.88-1.13l-.95-2.17a5.93,5.93,0,0,1-2.91.76,2.61,2.61,0,0,1-2.62-1.49h7a5.54,5.54,0,0,0,.12-1.15,4.86,4.86,0,1,0-9.71.05,4.81,4.81,0,0,0,5.19,5.13Zm10.82-.19H64V15.33H61.48Zm6.39,0h4l2.6-9.87H71.75l-1.88,8-1.91-8H65.29ZM80,17.66a2.23,2.23,0,0,1,2.4,1.75H77.6A2.23,2.23,0,0,1,80,17.66Zm-29.7,0a2.24,2.24,0,0,1,2.39,1.75h-4.8a2.2,2.2,0,0,1,2.4-1.75Zm58.81,5.12a2.39,2.39,0,0,1-1.81-.68,2.42,2.42,0,0,1-.7-1.8,2.51,2.51,0,0,1,5,0,2.41,2.41,0,0,1-2.5,2.48Zm-72.77-2.5a2.51,2.51,0,0,1,5,0,2.51,2.51,0,0,1-5,0Zm61.74,2.5a2.39,2.39,0,0,1-1.81-.68,2.42,2.42,0,0,1-.7-1.8,2.51,2.51,0,0,1,5,0,2.39,2.39,0,0,1-.7,1.8,2.36,2.36,0,0,1-1.8.68Zm-7.27-4.9a2.3,2.3,0,0,1,1.39.44l1.18-2.68a3.3,3.3,0,0,0-1.81-.5,3,3,0,0,0-2.65,1.49l-.25-1.25H86.1l.42,1.93v7.92H89V18.94a1.89,1.89,0,0,1,1.8-1.06ZM41.65,25.2h2.6l-.44-2.05V11H41.32v5.56a3.86,3.86,0,0,0-3-1.39c-2.49,0-4.42,2.1-4.42,5.14s1.93,5.13,4.42,5.13a3.86,3.86,0,0,0,3-1.46Z" })
  );
}

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ibm;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ibm() {
  return _react2.default.createElement(
    "svg",
    { width: "50", height: "40", viewBox: "0 0 50 40" },
    _react2.default.createElement("path", { d: "M0,10v1.37H9.73V10Zm11.11,0v1.37H25A5.29,5.29,0,0,0,21.69,10ZM27.7,10v1.37h8.39L35.59,10Zm14.41,0-.5,1.37h8.31V10ZM0,12.66V14H9.73V12.66Zm11.11,0V14H26.59a3.54,3.54,0,0,0-.5-1.37Zm16.59,0V14H37l-.46-1.37Zm13.41,0L40.65,14h9.27V12.66ZM2.8,15.32v1.37H7V15.32Zm11.11,0v1.37h4.21V15.32Zm8.31,0v1.37h4.22a4.57,4.57,0,0,0,.27-1.37Zm8.28,0v1.37H38l-.5-1.37Zm9.69,0-.5,1.37H47.2V15.32ZM2.8,18v1.35H7V18Zm11.11,0v1.35H24.67A4.8,4.8,0,0,0,25.86,18ZM30.5,18v1.35h4.21v-.76l.27.76H42.7l.3-.76v.76h4.2V18H39.29l-.42,1.15L38.45,18ZM2.8,20.65V22H7V20.65Zm11.11,0V22h12a4.57,4.57,0,0,0-1.19-1.36Zm16.59,0V22h4.21V20.65Zm5,0L36,22h5.79l.48-1.36Zm7.51,0V22H47.2V20.65ZM2.8,23.31v1.37H7V23.31Zm11.11,0v1.37h4.21V23.31Zm8.31,0v1.37h4.49a4.57,4.57,0,0,0-.27-1.37Zm8.28,0v1.37h4.21V23.31Zm5.94,0,.49,1.37h3.88l.5-1.37Zm6.55,0v1.37H47.2V23.31ZM.08,26v1.37H9.81V26Zm11,0v1.37h15a3.54,3.54,0,0,0,.5-1.37Zm16.67,0v1.37h6.93V26Zm9.61,0,.51,1.37h2L40.35,26ZM43,26v1.37h7V26ZM.08,28.63V30H9.81V28.63Zm11,0V30H21.69A5.29,5.29,0,0,0,25,28.63Zm16.67,0V30h6.93V28.63Zm10.58,0L38.85,30h.08l.5-1.37Zm4.63,0V30h7V28.63Z" })
  );
}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Monzo;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Monzo() {
  return _react2.default.createElement(
    "svg",
    { width: "70", height: "40", viewBox: "0 0 70 40" },
    _react2.default.createElement("path", { d: "M0,25.67V14.26H3.13v1.53a3.51,3.51,0,0,1,3.21-1.74,3.63,3.63,0,0,1,3.27,1.82,4.7,4.7,0,0,1,3.63-1.82c2.66,0,4.15,1.44,4.15,4.1v7.52H14V19.49c0-1.6-.35-2.32-1.64-2.32s-2,.79-2,2.32v6.18H7V19.49c0-1.6-.35-2.32-1.64-2.32s-2,.79-2,2.32v6.18Z" }),
    _react2.default.createElement("path", { d: "M25.54,22.81a2.84,2.84,0,0,0,2-.84,2.68,2.68,0,0,0,.79-2,2.79,2.79,0,1,0-2.78,2.8Zm-4.41-7a6.37,6.37,0,0,1,8.71-.12A5.83,5.83,0,0,1,31.76,20,5.71,5.71,0,0,1,30,24.25,6.21,6.21,0,0,1,25.51,26a5.9,5.9,0,0,1-4.44-1.83,5.88,5.88,0,0,1,.06-8.39Z" }),
    _react2.default.createElement("path", { d: "M33.72,25.7V14.3H37v1.53a3.71,3.71,0,0,1,3.33-1.75,3.77,3.77,0,0,1,4,4.1V25.7H40.88V19.52c0-1.59-.34-2.31-1.68-2.31s-2,.78-2,2.31V25.7Z" }),
    _react2.default.createElement("path", { d: "M62.76,22.81a2.81,2.81,0,1,0-2-4.78A2.72,2.72,0,0,0,60,20,2.79,2.79,0,0,0,62.76,22.81Zm-4.41-7a6.37,6.37,0,0,1,8.71-.12A5.89,5.89,0,0,1,69,19.93a5.72,5.72,0,0,1-1.78,4.29A6.25,6.25,0,0,1,62.74,26a5.91,5.91,0,0,1-4.46-1.83A5.85,5.85,0,0,1,56.56,20a5.72,5.72,0,0,1,1.79-4.22Z" }),
    _react2.default.createElement("path", { d: "M46.53,25.7V23.32l4.85-6.07H46.53V14.3h8.75V17L51,22.75h4.36V25.7Z" })
  );
}

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Stripe;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Stripe() {
  return _react2.default.createElement(
    "svg",
    { width: "62", height: "40", viewBox: "0 0 62 40" },
    _react2.default.createElement("path", { d: "M62,20.42c0-4.43-2.13-7.93-6.2-7.93S49.22,16,49.22,20.41c0,5.2,2.93,7.86,7.08,7.86a9.66,9.66,0,0,0,4.81-1.12V23.68a9,9,0,0,1-4.22,1c-1.68,0-3.15-.6-3.35-2.6H62C62,21.73,62,20.87,62,20.42Zm-8.51-1.63c0-1.95,1.19-2.77,2.27-2.77s2.17.82,2.17,2.77Z" }),
    _react2.default.createElement("path", { d: "M42.51,12.49a4.72,4.72,0,0,0-3.36,1.36L39,12.77h-3.8V33l4.31-.92v-4.9a4.77,4.77,0,0,0,3,1.09c3.09,0,5.89-2.49,5.89-8C48.41,15.22,45.57,12.49,42.51,12.49Zm-1,12a2.61,2.61,0,0,1-2-.83V17.18a2.56,2.56,0,0,1,2-.86c1.58,0,2.66,1.77,2.66,4s-1.05,4.09-2.65,4.09Z" }),
    _react2.default.createElement("path", { d: "M29.25,11.45l4.31-.92V7l-4.31.93Z" }),
    _react2.default.createElement("path", { d: "M29.25,12.77h4.31V28H29.25Z" }),
    _react2.default.createElement("path", { d: "M24.61,14.05l-.26-1.28H20.63V28h4.3V17.67a3,3,0,0,1,3.28-.91v-4A2.93,2.93,0,0,0,24.61,14.05Z" }),
    _react2.default.createElement("path", { d: "M16,9l-4.2.87V23.74a4.29,4.29,0,0,0,1.25,3.15,4.47,4.47,0,0,0,3.18,1.31,6.67,6.67,0,0,0,3-.57V24.17c-.55.22-3.27,1-3.27-1.54V16.47h3.27v-3.7H16Z" }),
    _react2.default.createElement("path", { d: "M4.35,17.18c0-.67.56-.93,1.46-.93a9.53,9.53,0,0,1,4.28,1.15V13.27a11.35,11.35,0,0,0-4.28-.78C2.33,12.49,0,14.32,0,17.4c0,4.79,6.54,4,6.54,6.07,0,.79-.69,1.05-1.65,1.05a10.58,10.58,0,0,1-4.7-1.37v4.14a11.77,11.77,0,0,0,4.69,1c3.54,0,6-1.78,6-4.9C10.92,18.21,4.35,19.13,4.35,17.18Z" })
  );
}

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Trainline;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Trainline() {
  return _react2.default.createElement(
    "svg",
    { width: "90", height: "40", viewBox: "0 0 90 40" },
    _react2.default.createElement("path", { d: "M85.53,18.89c0-1.24-.84-2.43-2.83-2.43a2.78,2.78,0,0,0-2.84,2.43Zm3.21,4a5.71,5.71,0,0,1-5.7,3.9A6.12,6.12,0,0,1,78.39,25a6.58,6.58,0,0,1-1.88-4.75,6.5,6.5,0,0,1,1.76-4.6,6.09,6.09,0,0,1,4.4-1.92c3.87,0,6.22,2.42,6.22,6.39v1h-9A3,3,0,0,0,83,23.92,2.72,2.72,0,0,0,85.88,22ZM66.82,19.39a2.4,2.4,0,0,1,.61-1.83,2.26,2.26,0,0,1,1.73-.74,2.15,2.15,0,0,1,1.74.64,2.29,2.29,0,0,1,.62,1.79v7.16h3.42V18.66c0-2.73-1.45-4.92-4.56-4.92a4.3,4.3,0,0,0-3.62,1.84V14H63.43V26.35h3.42Zm-8.89-5.27h3.42V26.41H57.93ZM59.63,8a2.13,2.13,0,0,1,2.11,2.07,2.16,2.16,0,0,1-.64,1.47,2,2,0,0,1-1.47.54,2.1,2.1,0,0,1-2.12-2A2.13,2.13,0,0,1,59.63,8ZM40.72,19.36a2.34,2.34,0,0,1,.62-1.81,2.25,2.25,0,0,1,1.73-.73,2.15,2.15,0,0,1,1.73.64,2.3,2.3,0,0,1,.62,1.79v7.16h3.42V18.66c0-2.73-1.45-4.92-4.56-4.92a4.3,4.3,0,0,0-3.62,1.84V14H37.33V26.35h3.42Zm-9-5.27h3.41V26.41H31.72ZM33.35,8a2.11,2.11,0,0,1,2.11,2.07,2.08,2.08,0,0,1-.64,1.47,2,2,0,0,1-1.47.54,2.09,2.09,0,0,1-2.12-2A2.16,2.16,0,0,1,33.35,8ZM23.68,24.34A1.44,1.44,0,0,1,22.56,24,1.53,1.53,0,0,1,22,22.92c0-1,.68-1.43,1.58-1.54L26.46,21v.53a2.63,2.63,0,0,1-.73,2.11A2.44,2.44,0,0,1,23.68,24.34Zm-5-1.25c0,2,1.64,3.73,4.35,3.73A4,4,0,0,0,26.7,25a12.3,12.3,0,0,0,.12,1.48H30a16.7,16.7,0,0,1-.18-2v-6c0-2.49-1.5-4.7-5.49-4.7-3.42,0-5.2,2.13-5.38,4.08l3,.66a2.22,2.22,0,0,1,2.42-2c1.44,0,2.11.71,2.11,1.6,0,.42-.25.77-1,.89l-3.09.47C20.3,19.66,18.66,20.94,18.66,23.09Zm-1-5.68a9,9,0,0,0-1-.12c-1.75,0-3.26.83-3.26,3.53v5.63H9.93V14.09h3.33v1.84A3.69,3.69,0,0,1,16.82,14a2.55,2.55,0,0,1,.78,0ZM8.1,14.27v2.91H4.17a5.67,5.67,0,0,0,1-.72,5.29,5.29,0,0,0,1.32-2.19ZM1,17.18H0V14.27H5.5A4.56,4.56,0,0,1,3.81,16.4,5.62,5.62,0,0,1,1,17.18Zm6.09,6.5a3.65,3.65,0,0,0,1-.12v2.79a5,5,0,0,1-1.88.3,3.59,3.59,0,0,1-3.94-3.79V17.94H5.62v4.39C5.62,23.29,6.11,23.68,7.06,23.68ZM5.62,13.51V10.6h-3v1.72a1.88,1.88,0,0,1-.37,1.17ZM56.06,23.68h-.6c-1,0-1.46-.35-1.46-1.41V8.53H50.68V22.86a3.58,3.58,0,0,0,3.92,3.79,5.08,5.08,0,0,0,1.46-.18Z" })
  );
}

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LogoRow;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Spacing = __webpack_require__(16);

var _Spacing2 = _interopRequireDefault(_Spacing);

var _general = __webpack_require__(206);

var _general2 = _interopRequireDefault(_general);

var _color = __webpack_require__(207);

var _color2 = _interopRequireDefault(_color);

var _opacity = __webpack_require__(208);

var _opacity2 = _interopRequireDefault(_opacity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OPACITY_PREFIX = 'opacity-';

function LogoRow(_ref) {
  var _cx;

  var align = _ref.align,
      logos = _ref.logos,
      color = _ref.color,
      opacity = _ref.opacity,
      spacing = _ref.spacing;

  var padding = void 0;

  if (align === 'left') {
    padding = 'right';
  } else if (align === 'right') {
    padding = 'left';
  } else {
    padding = 'leftRight';
  }

  var containerClass = (0, _classnames2.default)(_general2.default.container, (_cx = {}, _defineProperty(_cx, _general2.default.containerCentered, align === 'center'), _defineProperty(_cx, _general2.default.containerLeft, align === 'left'), _defineProperty(_cx, _general2.default.containerRight, align === 'right'), _cx));

  var itemClass = (0, _classnames2.default)(_color2.default[color], _opacity2.default[OPACITY_PREFIX + opacity]);

  return _react2.default.createElement(
    'div',
    { className: containerClass },
    logos.map(function (item) {
      var Logo = item.logo;
      return _react2.default.createElement(
        _Spacing2.default,
        {
          key: item.id,
          position: 'topBottom',
          size: spacing,
          type: 'margin'
        },
        _react2.default.createElement(
          _Spacing2.default,
          { size: spacing, position: padding, type: 'margin' },
          _react2.default.createElement(
            'div',
            { className: itemClass },
            _react2.default.createElement(
              _Spacing2.default,
              { size: 'xs', position: padding, type: 'margin' },
              _react2.default.createElement(Logo, null)
            )
          )
        )
      );
    })
  );
}

var opacities = Object.keys(_opacity2.default).map(function (opacity) {
  return Number(opacity.replace(OPACITY_PREFIX, ''));
});

LogoRow.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  color: _propTypes2.default.string,
  logos: _propTypes2.default.array.isRequired,
  opacity: _propTypes2.default.oneOf(opacities),
  spacing: _propTypes2.default.oneOf(['xxs', 'xs', 's', 'm'])
};

LogoRow.defaultProps = {
  align: 'center',
  color: 'silver',
  opacity: 70,
  spacing: 'm'
};

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"general__container___5mWnk display-flex alignItems-center flexWrap-wrap","containerCentered":"general__containerCentered___3cwFm justifyContent-center","containerLeft":"general__containerLeft___1bOp5 justifyContent-center breakPointM-justifyContent-start","containerRight":"general__containerRight___38hxE justifyContent-center breakPointM-justifyContent-flexEnd"};

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"white":"color__white___2sURC fill-white","silver":"color__silver___2zSWu fill-silver"};

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"opacity-10":"opacity__opacity-10___2X0it opacity-10","opacity-20":"opacity__opacity-20___2YdYl opacity-20","opacity-30":"opacity__opacity-30___1Uzno opacity-30","opacity-40":"opacity__opacity-40___1CEDZ opacity-40","opacity-50":"opacity__opacity-50___Zg5RG opacity-50","opacity-60":"opacity__opacity-60___1BLFf opacity-60","opacity-70":"opacity__opacity-70___FT5gd opacity-70","opacity-80":"opacity__opacity-80___s20V7 opacity-80","opacity-90":"opacity__opacity-90___3Tcyg opacity-90","opacity-100":"opacity__opacity-100___373RD opacity-100"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-logo-row.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-logo-row.js
// module id = 1107
// module chunks = 168707334958949